/*
 *   File : notification-modal.js
 *   Author : https://evoqins.com
 *   Description : notification modal component
 *   Integrations : NA
 *   Version : 1.0.0
 */

import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import { PrimaryButton } from "../Buttons";

/* ---------- Overlay (same as SuccessModal) ---------- */
const ModalOverlay = ({ onClose }) => {
  useEffect(() => {
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => (document.body.style.overflow = prev);
  }, []);

  return (
    <div
      className="position-fixed top-0 start-0 w-100 h-100 bg-dark bg-opacity-25"
      style={{ zIndex: 1040 }}
      onClick={onClose}
    />
  );
};

/* ---------- Notification Modal ---------- */
export default function NotificationModal({
  open = false,
  title,
  content,
  time,
  onCancel,
  imgSrc = require("../../Assets/Images/Components/Modal/phone-modal.webp"),
}) {
  if (!open) return null;

  return createPortal(
    <>
      {/* Overlay */}
      <ModalOverlay onClose={onCancel} />

      {/* Modal */}
      <div
        className="position-fixed overflow-hidden top-50 start-50 translate-middle e-modal-portal rounded-28 shadow p-0"
        style={{
          zIndex: 1055,
          width: "600px",
        }}
        onClick={(e) => e.stopPropagation()} // prevent closing when clicking inside
      >
        <div
          style={{ backdropFilter: "blur(2px)" }}
          className="d-flex flex-column rg-24 justify-content-center bg-white bg-opacity-80 align-items-center p-24"
        >
          {/* Header */}
          <div className="d-flex justify-content-between w-100">
            <h5 className="fw-500 fs-16 text-start lh-1 text-eerie-black mb-0">
              View push notification
            </h5>

            <PrimaryButton
              icon="close"
              ClassName="bg-transparent p-0"
              onPress={onCancel}
            />
          </div>

          {/* Image */}
          <div className="d-flex justify-content-center h-100 w-100 position-relative">
            <img src={imgSrc} width={213} height={428} alt="Phone preview" />
            <div
              style={{ width: "200px", top: "40%" }}
              className="bg-white d-flex column-gap-2 rounded-8 p-2 bg-opacity-43 position-absolute"
            >
              <div className=" d-flex flex-column justify-content-center">
                <div className="bg-white rounded-2 p-1">
                  <img
                    width={20}
                    height={20}
                    src={require("../../Assets/Images/logo-icon.svg").default}
                    alt="funds app"
                  />
                </div>
              </div>
              <div className="d-flex flex-column w-100 overflow-hidden">
                <div className="d-flex justify-content-between align-items-center pb-1">
                  <h5 className="fw-500 mb-0 fs-8 lh-8 text-pastel-gray truncate-3">
                    {title}
                  </h5>
                  <p className="mb-0 text-nowrap fw-400 fs-6x text-cultured-gray">
                    {time ? time : "3m ago"}
                  </p>
                </div>
                <p className="fw-400 fs-7 mb-0 lh-7 text-pastel-gray truncate-4 text-wrap">
                  {content}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>,
    document.body
  );
}
